module.exports = __webpack_public_path__ + "static/media/syringe.b18dde72.svg";